import React from 'react';
import NavLink from './NavLink';
import Dropdown from './Dropdown';
import messages from './messages';
import { prices } from './groups';
import { CgDollar } from 'react-icons/all';

const PricesDropdown = ({ closeSidebar }) => (
  <Dropdown icon={<CgDollar />} label={messages.prices}>
    {prices.map((item, index) => (
      <NavLink
        key={index}
        name={item.name}
        icon={item.icon}
        route={item.url}
        role={item.role}
        module={item.module}
        closeSidebar={closeSidebar}
      />
    ))}
  </Dropdown>
);

export default PricesDropdown;
